import { FUEL_TYPE_LABELS } from '@/features/attributes/constants/attributeTranslationKeys'

/**
 * Returns the i18n translation key for a given fuel type.
 *
 * @param fuelTypeKey - The key representing the fuel type.
 *   Should correspond to one of the values defined in `FUEL_VALUES`.
 * @returns The corresponding i18n translation key string.
 *
 * @example
 * getFuelTypeTranslation('diesel');
 * // Returns: 'listing:attributes.fuel_type.diesel'
 */
export const getFuelTypeTranslation = (fuelTypeKey: string) => {
  return FUEL_TYPE_LABELS[fuelTypeKey]
}
